import styled from 'styled-components';

import { Box } from '@sso/shared/core';

const FlexForm = styled(Box.Form)`
    display: flex;
    flex-direction: column;
`;

export default FlexForm;
